import { useEffect, useState } from 'react';
import './styles/booking-banner.css';

// Booking-confirmation banner. Everyone who reaches the NTA has already booked their
// intake call, so this simply reassures them not to double-book. It shows on load,
// counts down, then smoothly collapses itself away — WITHOUT reloading the page (a real
// reload here would wipe answers someone already started). Self-contained; all classes
// are namespaced `pnta-` so nothing collides with the assessment styles.
const SECONDS = 30;

export default function BookingBanner() {
  const [left, setLeft] = useState(SECONDS);
  const [hiding, setHiding] = useState(false); // triggers the collapse transition
  const [gone, setGone] = useState(false);     // removes it from layout after the transition

  // Tick down once a second via a self-rescheduling timeout (no side effects inside a
  // state updater, so it stays correct under React StrictMode's double-invoke in dev).
  useEffect(() => {
    if (left <= 0) return undefined;
    const t = setTimeout(() => setLeft((n) => n - 1), 1000);
    return () => clearTimeout(t);
  }, [left]);

  // At zero: collapse, then unmount once the 0.6s CSS transition has run.
  useEffect(() => {
    if (left > 0) return undefined;
    setHiding(true);
    const t = setTimeout(() => setGone(true), 700);
    return () => clearTimeout(t);
  }, [left]);

  if (gone) return null;

  return (
    <div className={`pnta-booked${hiding ? ' pnta-hide' : ''}`}>
      <div className="pnta-banner" role="status">
        <div className="pnta-icon" aria-hidden="true">✓</div>
        <div className="pnta-copy">
          <div className="pnta-h">You’re booked — your 15-minute intake call is confirmed</div>
          <p>
            Your confirmation email is on its way — <b>no need to book again</b>. There’s
            nothing you need to do before this call other than show up. If you have time
            right now, please fill out the assessment below so your health advisor can be
            prepared for your call.
          </p>
        </div>
      </div>
      <div className="pnta-checkrow">
        <span className="pnta-pulse" aria-hidden="true" />
        <span>You’re all set — this message will hide itself in <b>{left}</b>s.</span>
      </div>
    </div>
  );
}
